import type {AxiosStatic} from 'axios';
import axios from 'axios';
import SweetAlert from "sweetalert2";
import router from "@/AdminApp/router.ts";
import Cookie from "js-cookie";

declare global {
	interface Window {
		axios: AxiosStatic;
	}
}

window.axios = axios;

axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Admin website secure
if (Cookie.get('jwt_session')) {
	window.axios.defaults.headers.common["Authorization"] = 'Bearer ' + atob(<string>Cookie.get('jwt_session'));
}

// Axios Interceptors Request
window.axios.interceptors.request.use(function (request) {
	return request;
});
// Axios Interceptors Response
window.axios.interceptors.response.use(function (response) {
	return response;
}, function (error) {
	switch (error.response.status) {
		case 403:
			SweetAlert.fire('', 'Nincs jogosultságod megtekinteni az oldalt!', 'error');
			router.push({name: 'dashboard'});
			break;
		case 401:
			Cookie.remove('jwt_session');
			//location.href = '/';
			break;
	}
	return Promise.reject(error)
});
